import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 50;
  background: rgba(0, 0, 0, 0.3);
`;
const BlockWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0px;
`;
const BlockWrapperDisable = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 24px 0px; */
`;
const StyledSpinner = styled.svg`
  animation: rotate 2s linear infinite;
  width: 50px;
  height: 50px;

  & .path {
    stroke: #5652bf;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export function SpinnerWrapper() {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  );
}

export function SpinnerBlock() {
  return (
    <BlockWrapper>
      <Spinner />
    </BlockWrapper>
  );
}

export function SpinnerBlockWrapper() {
  return (
    <BlockWrapperDisable>
      <Spinner />
    </BlockWrapperDisable>
  );
}

function Spinner() {
  return (
    <StyledSpinner viewBox="0 0 50 50">
      <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
    </StyledSpinner>
  );
}

export default Spinner;
